module.exports = __webpack_public_path__ + "img/8af6d360489150e655401728f9a0e330.png";